import { Tooltip } from '@repo/ui/components';
import { formatNumber } from 'types';
import React from 'react';
import { ttCodes } from '../../common';

export const financePriceFormatter = (value: any, _rowdata: any, postfix: string = 'kr') => {
  if (typeof value !== 'number' && !value) return '';
  return `${formatNumber(value)} ${postfix ?? ''}`;
};

export const priceFormatter = (value: any, postfix: string = 'kr') => {
  if (typeof value !== 'number' && !value) return '';
  return `${formatNumber(value)} ${postfix ?? ''}`;
};

export const monthlyPriceFormatter = (value: any, rowData: any) => {
  if (typeof value !== 'number' && !value) return '-';
  return `${formatNumber(value)}`;
};

export const monthlyPriceFormatterBold = (value: any, rowData: any) => {
  if (typeof value !== 'number' && !value) return '-';
  return <span className="text-extrabold">{formatNumber(value)}</span>;
};

export const ttCodeFormatter = (code?: number) => {
  if (!code) return '';
  const desc = ttCodes.find((x) => x.id === code)?.description;
  return (
    <Tooltip content={desc} enabledCondition={!!desc}>
      <span className="text-sm/[170%]">{code}</span>
    </Tooltip>
  );
};

export const getIfsAvailabilityCodeFromAvailabilityCode = (availability: string): string => {
  return availability?.split('-')?.[1]?.trim() || '';
};
